import { watch } from 'vue'
import { useAppPage } from "@/composables/useAppPage";
import Swal from 'sweetalert2'

export function useFlashMessages() {
    const { flash } = useAppPage();

    watch(flash, (value) => {
        if (!value) return;

        if (value.error) {
            Swal.fire({
                title: 'Algo inesperado aconteceu...',
                text: value.error,
                icon: 'error',
                confirmButtonColor: 'var(--color-primary)'
            });
        }

        if (value.warning) {
            Swal.fire({
                title: 'Atenção',
                text: value.warning,
                icon: 'warning',
                confirmButtonColor: 'var(--color-primary)'
            });
        }
    }, { immediate: true });
}
